<div class="Maters">
        <router-outlet  (activate)='onActivate($event)'  ></router-outlet>

       
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MasterPage/Master.html